import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './sharelink.routes';
import addHtml from './modal/add.html';

export class ShareLinkController {
    $http;
    socket;
    sharelinks = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;

        this.features = [
            { value: 'emotion_sharing_text', name: 'emotion_sharing_text' },
            { value: 'reading_sharing_text', name: 'reading_sharing_text' },
            { value: 'sharing_image', name: 'sharing_image' },
            { value: 'dailyverse_sharing_text', name: 'dailyverse_sharing_text' },
            { value: 'sharing_audio', name: 'sharing_audio' },
            { value: 'account_sharing_link', name: 'account_sharing_link' },
            { value: 'sharing_covid', name: 'sharing_covid' },
            { value: 'sharing_feed', name: 'sharing_feed' },
            { value: 'sharing_group', name: 'sharing_group' },
        ];

        this.sharePlatforms = [
            { value: 'iOS', name: 'iOS' },
            { value: 'Android', name: 'Android' }
        ]

        this.openPlatforms = [
            { value: 'iOS', name: 'iOS' },
            { value: 'Android', name: 'Android' }
        ]

        this.firstOpen = [
            { value: 0, name: '否' },
            { value: 1, name: '是' }
        ]

        this.isDisabled = false;
        this.popup2 = {
            opened: false
        };

        this.open2 = function () {
            this.popup2.opened = true;
        };


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('sharelinks');
        });
    }

    TransformationFirstOpen(value) {
        var ret = _.find(this.firstOpen, { value: value });
        if (ret) {
            return ret.name;
        }
        return '';
    }

    $onInit() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/sharelinks/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {


                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;

                        this.sharelinks = response.data.data;
                        this.socket.syncUpdates('sharelinks', this.sharelinks);
                    }

                });
        } else {
            this.$location.path('main')
        }
    }

    search(val) {
        if (val === true) {
            this.currentPage = 1;
        }

        const payload = angular.copy(this.filters);
        if (payload && payload.createdAt) {
            payload.createdAt = new Date(payload.createdAt).valueOf();
        }


        const ret = {
            filters: payload || {},
            page: this.currentPage - 1,
            size: 20
        };
        if (this.$cookies.get('token')) {

            this.$http.get('/api/sharelinks/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: ret
            })
                .then(response => {
                    if (response.data.data) {
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.sharelinks = response.data.data;

                        this.socket.syncUpdates('sharelinks', this.sharelinks);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }
}

export default angular.module('tttApp.sharelink', [uiRouter])
    .config(routing)
    .component('sharelink', {
        template: require('./sharelink.html'),
        controller: ShareLinkController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/sharelink/sharelink.component.js